// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3BSCj","content":"Consent_content__wA5pm","footer":"Consent_footer__3hQAE"};